import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { stats } from '@/mocks/home';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20theater%20atmosphere%20with%20warm%20golden%20and%20deep%20crimson%20gradient%20lighting%2C%20abstract%20film%20reel%20and%20projector%20beam%20visual%2C%20luxurious%20dark%20texture%20background%2C%20dramatic%20movie%20premiere%20vibe%2C%20elegant%20cinema%20ambiance&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="蜜桃影视"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 flex flex-col items-center text-center">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-white mb-4 tracking-wide">
          {t('hero.title')}
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-8 max-w-xl">
          {t('hero.subtitle')}
        </p>

        <div className="w-full max-w-xl mb-10">
          <div className="relative">
            <input
              type="text"
              placeholder={t('hero.search_placeholder')}
              className="w-full pl-12 pr-6 py-4 rounded-full text-base bg-white/15 backdrop-blur-sm text-white placeholder:text-white/60 border border-white/25 focus:bg-white/25 outline-none transition-all duration-300"
            />
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-white/70 text-lg"></i>
            <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-primary-500 hover:bg-primary-600 text-white px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors">
              搜索
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-white/60 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <Link
          to="/category/movies"
          className="mt-10 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-8 py-3.5 rounded-full text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-300 hover:scale-105"
        >
          {t('hero.cta')}
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}